import React from "react";
import AdminEditSubCharacter from "../../Components/Admin/AdminEditSubCharacter";
import SideBar from "../../Components/Admin/SideBar";

const AdminEditSubCharacterPage = ()=>{
    return (
      <AdminEditSubCharacter />
    )
}

export default AdminEditSubCharacterPage;